import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import './BuyerAgreementCard.css';

const BuyerAgreementCard = ({ agreement, onClick, isClosed = false, isSuperAdmin = false }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) onClick();
    navigate(`/buyer-agreement/${agreement.id}`);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    try {
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
      return new Date(dateStr).toLocaleDateString('en-US', {
        year: 'numeric', month: 'short', day: 'numeric',
      });
    } catch {
      return dateStr;
    }
  };

  const formatUploadDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    try {
      if (typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        const [year, month, day] = dateStr.split('-').map(Number);
        return new Date(year, month - 1, day).toLocaleDateString('en-US', {
          year: 'numeric', month: 'short', day: 'numeric',
        });
      }
      const date = new Date(dateStr);
      if (Number.isNaN(date.getTime())) return dateStr;
      return date.toLocaleDateString('en-US', {
        year: 'numeric', month: 'short', day: 'numeric',
      });
    } catch {
      return dateStr;
    }
  };

  const buyers = (agreement.parties || []).filter(p => p.role === 'buyer' || p.role === 'co_buyer');
  const buyerNames = buyers.map(p => p.name).filter(Boolean);
  const firstBuyerLastName = buyers[0]?.name?.split(' ').pop() || buyerNames[0] || 'N/A';
  const buyersDisplay = buyerNames.length > 0
    ? buyerNames.map((name, i) => (
        <Fragment key={i}>{name}{i < buyerNames.length - 1 && <>{' &'}<br /></>}</Fragment>
      ))
    : 'N/A';

  const agent = (agreement.parties || []).find(p => p.role === 'buyers_agent');
  const keyfloAgent = isSuperAdmin && agent?.name ? agent.name : null;

  const uploadedDate = agreement.created_at || null;

  const statusLabel = isClosed ? (agreement.status || 'closed').toUpperCase() : null;
  const hasIssues = !isClosed && Number(agreement.open_compliance_issues_count) > 0;

  return (
    <div
      className={`buyer-agreement-card ${isClosed ? 'buyer-agreement-card-closed' : ''}`}
      onClick={handleClick}
    >
      {hasIssues && (
        <div className="badge-group">
          <div className="badge-issue">
            {agreement.open_compliance_issues_count} Issue{agreement.open_compliance_issues_count !== 1 ? 's' : ''}
          </div>
        </div>
      )}
      <div className="buyer-agreement-card-header">
        <h3 className="buyer-agreement-title">
          {firstBuyerLastName}
        </h3>
        <span className="buyer-agreement-type-label">{statusLabel || 'Buyer Agreement'}</span>
      </div>
      <div className="card-body">
        <div className="info-row">
          <span className="info-label">Buyer</span>
          <span className="info-value">{buyersDisplay}</span>
        </div>

        <div className="closing-date-section">
          <div className="info-row" style={{ marginBottom: 0 }}>
            <span className="info-label">Expires</span>
            <span className="info-value">{agreement.expiration_date || 'N/A'}</span>
          </div>
        </div>
      </div>
      <div className="card-footer">
        {keyfloAgent && (
          <div className="meta-row" style={{ marginBottom: '4px' }}>
            <span style={{ fontSize: '0.72rem', color: '#D4A574', fontWeight: 600 }}>
              {keyfloAgent}
            </span>
          </div>
        )}
        <div className="meta-row">
          {isClosed && <span className="closed-label">CLOSED</span>}
          <span>Uploaded: {formatUploadDate(uploadedDate)}</span>
        </div>
      </div>
    </div>
  );
};

export default BuyerAgreementCard;
